import { A as Api } from './Api.js';

class BusinessService {
    async fetchBusiness(businessId, authToken, apiOrigin = "https://wc-proxy.justifi.ai") {
        const endpoint = `entities/business/${businessId}`;
        return Api({ authToken, apiOrigin }).get({ endpoint });
    }
    async patchBusiness(authToken, businessId, payload) {
        const endpoint = `entities/business/${businessId}`;
        return Api({ authToken, apiOrigin: "https://wc-proxy.justifi.ai" }).patch({
            endpoint,
            body: payload,
        });
    }
}
class IdentityService {
    async fetchIdentity(identityId, authToken) {
        const endpoint = `entities/identity/${identityId}`;
        return Api({ authToken, apiOrigin: "https://wc-proxy.justifi.ai" }).get({ endpoint });
    }
    async patchIdentity(authToken, identityId, payload) {
        const endpoint = `entities/identity/${identityId}`;
        return Api({ authToken, apiOrigin: "https://wc-proxy.justifi.ai" }).patch({
            endpoint,
            body: payload,
        });
    }
    async postIdentity(authToken, payload) {
        const endpoint = `entities/identity`;
        return Api({ authToken, apiOrigin: "https://wc-proxy.justifi.ai" }).post({
            endpoint,
            body: payload,
        });
    }
}
class BusinessBankAccountService {
    async postBankAccount(authToken, payload) {
        const endpoint = `entities/bank_accounts`;
        return Api({ authToken, apiOrigin: "https://wc-proxy.justifi.ai" }).post({
            endpoint,
            body: payload,
        });
    }
}
class DocumentRecordService {
    async postDocumentRecord(authToken, payload) {
        const endpoint = `entities/document`;
        return Api({ authToken, apiOrigin: "https://wc-proxy.justifi.ai" }).post({
            endpoint,
            body: payload,
        });
    }
}

export { BusinessService as B, DocumentRecordService as D, IdentityService as I, BusinessBankAccountService as a };
